import styled, { css } from 'styled-components';

type ContainerProps = {
  width: number;
};

export const Container = styled.div`
  background: #d5d5d6;
  height: 3px;
  width: 100%;
`;

export const Progress = styled.div<ContainerProps>`
  ${({ width }) => css`
    background: var(--blue-einstein);
    height: 3px;
    width: ${width}%;
  `}
`;
